import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=3f5efe62&"
var script = {}
import style0 from "./ChatBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VImg,VSlideXReverseTransition})
